import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';

interface IconInputFieldProps {
  name: string;
  label: string;
  placeholder: string;
  icon: React.ComponentType<{ className?: string; size?: number }>;
  disabled?: boolean;
  form: UseFormReturn<any>;
  description?: string;
  type?: string;
  className?: string;
}

export const IconInputField: React.FC<IconInputFieldProps> = ({
  name, 
  label, 
  placeholder, 
  icon: Icon, 
  disabled = false, 
  form, 
  description, 
  type = "text",
  className
}) => (
  <FormField
    control={form.control}
    name={name}
    render={({ field }) => (
      <FormItem className={`space-y-2 ${className || ''}`}>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <FormLabel className={`sm:w-48 sm:flex-shrink-0 ${disabled ? "text-muted-foreground" : ""}`}>
            {label}
          </FormLabel>
          <FormControl>
            <div className="relative w-full sm:w-80">
              <Icon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" size={18} />
              <Input 
                className="pl-10" 
                placeholder={placeholder} 
                disabled={disabled} 
                type={type}
                {...field} 
              />
            </div>
          </FormControl>
        </div>
        {description && <FormDescription className="text-xs">{description}</FormDescription>}
        <FormMessage />
      </FormItem>
    )}
  />
);